// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swimlab-clerk-card {
    border-radius: 1.25rem;
    border: 1px solid color-mix(in srgb, var(--primary) 18%, var(--gray-200));
    background: linear-gradient(145deg, color-mix(in srgb, var(--primary) 7%, var(--bg-primary)) 0%, var(--bg-primary) 70%);
    box-shadow: 0 20px 45px rgba(15, 23, 42, 0.12);
    overflow: hidden;
}

.swimlab-clerk-title {
    font-size: 1.3rem;
    font-weight: 700;
    color: var(--text-primary);
    letter-spacing: -0.01em;
}

.swimlab-clerk-subtitle {
    color: var(--gray-600);
    line-height: 1.5;
}

.swimlab-clerk-logo {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 3.25rem;
    height: 3.25rem;
    border-radius: 1rem;
    background: linear-gradient(135deg, var(--primary), color-mix(in srgb, var(--primary) 55%, white));
    box-shadow: 0 10px 24px color-mix(in srgb, var(--primary) 26%, transparent);
    margin-bottom: 0.6rem;
}

.swimlab-clerk-social-button {
    border: 1px solid var(--gray-300);
    border-radius: 0.9rem;
    background: var(--bg-primary);
    color: var(--text-primary);
    font-weight: 600;
    transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
}

.swimlab-clerk-social-button:hover {
    border-color: var(--primary);
    box-shadow: 0 6px 16px rgba(37, 99, 235, 0.12);
    transform: translateY(-1px);
}

.swimlab-clerk-primary-button {
    border-radius: 999px;
    border: none;
    background: linear-gradient(135deg, var(--primary) 0%, color-mix(in srgb, var(--primary) 70%, var(--primary-dark, #1d4ed8)) 100%);
    color: #fff;
    font-weight: 700;
    box-shadow: 0 8px 20px color-mix(in srgb, var(--primary) 24%, transparent);
    transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;
}

.swimlab-clerk-primary-button:hover {
    filter: brightness(1.03);
    transform: translateY(-1px);
    box-shadow: 0 10px 24px color-mix(in srgb, var(--primary) 32%, transparent);
}

.swimlab-clerk-input {
    border: 1px solid var(--gray-300);
    border-radius: 0.8rem;
    background: var(--bg-primary);
    color: var(--text-primary);
    padding: 0.8rem 0.95rem;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.swimlab-clerk-input:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary) 16%, transparent);
}

.swimlab-clerk-label {
    color: var(--text-primary);
    font-weight: 600;
}

.swimlab-clerk-footer-link {
    color: var(--primary);
    font-weight: 600;
}

.swimlab-clerk-footer {
    padding-top: 0.35rem;
}

.cl-footer .cl-internal-1dauvpw,
.cl-footer .cl-internal-1fpq5at,
.cl-footer .cl-internal-1k7jtru,
.cl-footer .cl-internal-pe6vm4,
.cl-footer .cl-internal-y44tp9,
.cl-footer .cl-internal-1kjfvdp,
.cl-footer .cl-internal-1scq7x4,
.cl-footer .cl-internal-1scxde7 {
    display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/renderer/styles/clerk.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,yEAAyE;IACzE,uHAAuH;IACvH,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,kGAAkG;IAClG,2EAA2E;IAC3E,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;IACjC,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,gBAAgB;IAChB,gFAAgF;AACpF;;AAEA;IACI,4BAA4B;IAC5B,8CAA8C;IAC9C,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,iIAAiI;IACjI,WAAW;IACX,gBAAgB;IAChB,0EAA0E;IAC1E,0EAA0E;AAC9E;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,2EAA2E;AAC/E;;AAEA;IACI,iCAAiC;IACjC,qBAAqB;IACrB,6BAA6B;IAC7B,0BAA0B;IAC1B,uBAAuB;IACvB,0DAA0D;AAC9D;;AAEA;IACI,4BAA4B;IAC5B,yEAAyE;AAC7E;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;;;;;;;IAQI,wBAAwB;AAC5B","sourcesContent":[".swimlab-clerk-card {\n    border-radius: 1.25rem;\n    border: 1px solid color-mix(in srgb, var(--primary) 18%, var(--gray-200));\n    background: linear-gradient(145deg, color-mix(in srgb, var(--primary) 7%, var(--bg-primary)) 0%, var(--bg-primary) 70%);\n    box-shadow: 0 20px 45px rgba(15, 23, 42, 0.12);\n    overflow: hidden;\n}\n\n.swimlab-clerk-title {\n    font-size: 1.3rem;\n    font-weight: 700;\n    color: var(--text-primary);\n    letter-spacing: -0.01em;\n}\n\n.swimlab-clerk-subtitle {\n    color: var(--gray-600);\n    line-height: 1.5;\n}\n\n.swimlab-clerk-logo {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 3.25rem;\n    height: 3.25rem;\n    border-radius: 1rem;\n    background: linear-gradient(135deg, var(--primary), color-mix(in srgb, var(--primary) 55%, white));\n    box-shadow: 0 10px 24px color-mix(in srgb, var(--primary) 26%, transparent);\n    margin-bottom: 0.6rem;\n}\n\n.swimlab-clerk-social-button {\n    border: 1px solid var(--gray-300);\n    border-radius: 0.9rem;\n    background: var(--bg-primary);\n    color: var(--text-primary);\n    font-weight: 600;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;\n}\n\n.swimlab-clerk-social-button:hover {\n    border-color: var(--primary);\n    box-shadow: 0 6px 16px rgba(37, 99, 235, 0.12);\n    transform: translateY(-1px);\n}\n\n.swimlab-clerk-primary-button {\n    border-radius: 999px;\n    border: none;\n    background: linear-gradient(135deg, var(--primary) 0%, color-mix(in srgb, var(--primary) 70%, var(--primary-dark, #1d4ed8)) 100%);\n    color: #fff;\n    font-weight: 700;\n    box-shadow: 0 8px 20px color-mix(in srgb, var(--primary) 24%, transparent);\n    transition: transform 0.15s ease, box-shadow 0.15s ease, filter 0.15s ease;\n}\n\n.swimlab-clerk-primary-button:hover {\n    filter: brightness(1.03);\n    transform: translateY(-1px);\n    box-shadow: 0 10px 24px color-mix(in srgb, var(--primary) 32%, transparent);\n}\n\n.swimlab-clerk-input {\n    border: 1px solid var(--gray-300);\n    border-radius: 0.8rem;\n    background: var(--bg-primary);\n    color: var(--text-primary);\n    padding: 0.8rem 0.95rem;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.swimlab-clerk-input:focus {\n    border-color: var(--primary);\n    box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary) 16%, transparent);\n}\n\n.swimlab-clerk-label {\n    color: var(--text-primary);\n    font-weight: 600;\n}\n\n.swimlab-clerk-footer-link {\n    color: var(--primary);\n    font-weight: 600;\n}\n\n.swimlab-clerk-footer {\n    padding-top: 0.35rem;\n}\n\n.cl-footer .cl-internal-1dauvpw,\n.cl-footer .cl-internal-1fpq5at,\n.cl-footer .cl-internal-1k7jtru,\n.cl-footer .cl-internal-pe6vm4,\n.cl-footer .cl-internal-y44tp9,\n.cl-footer .cl-internal-1kjfvdp,\n.cl-footer .cl-internal-1scq7x4,\n.cl-footer .cl-internal-1scxde7 {\n    display: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
